export class SceneLifeCycleController {
  constructor(scene) {
    this.scene = scene;
    this._lifecycleOnAfterCreatedAllowed = true;
  }
  onAfterCreatedCallbackAllowed() {
    return this.scene.loadingController.loaded() && this._lifecycleOnAfterCreatedAllowed;
  }
  onAfterCreatedPrevent(callback) {
    this._lifecycleOnAfterCreatedAllowed = false;
    callback();
    this._lifecycleOnAfterCreatedAllowed = true;
  }
}
